import script from "./UCPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./UCPopover.vue?vue&type=script&setup=true&lang=js"

import "./UCPopover.vue?vue&type=style&index=0&id=0dfbfaeb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dfbfaeb"]])

export default __exports__